module.exports = __webpack_public_path__ + "static/img/kotok.a506d468.webp";